import axios from "axios";
import { StatusCodes } from "http-status-codes";

export const baseURL = process.env.REACT_APP_BASEURL;
export const baseImageURL = process.env.REACT_APP_BASE_IMAGE_URL;

export const apiService = axios.create({
  baseURL,
});

export const apiService2 = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
  },
});

export const apiService3 = axios.create({
  baseURL,
  headers: {
    Accept: "multipart/form-data",
  },
});

const handleUnauthorizedError = (instance) => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === StatusCodes.UNAUTHORIZED) {
        localStorage.removeItem("token");
        window.location.href = "/login";
        return Promise.resolve(null);
      }
      return Promise.reject(error);
    }
  );
};
apiService2.interceptors.request.use(async (config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  handleUnauthorizedError(apiService2);
  return config;
});

apiService3.interceptors.request.use(async (config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  handleUnauthorizedError(apiService3);
  return config;
});
